import { addMethod, string } from 'yup';

addMethod(string, 'postalCode', function (message) {
  return this.test('postalCode-test', message, (value) => {
    const regex = /(^[1-8]\d{4}$)|(^0[1-9]\d{3})|(^9[0-5]\d{3}$)|(^97[1-6]\d{2}$)|(^98[4678]\d{2}$)/;
    return regex.test(value ?? 'null');
  });
});
